var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import "../../../@common/styles/styles.scss";
import LoginModal from "./LoginModal";
import { isUserLoggedIn } from "base-ui-generic/Common/Helpers/RoutesHelper";
import { getFromServerAPIWithProvidedBearerToken, getFromServerAPIWithoutRedirections, } from "base-ui-generic/Common/Helpers/ApiHelper";
import { clearAllValuesFromStorages, getAuthenticationType, getLoginName, } from "base-ui-generic/Common/Helpers/TokenHelper";
import { CORP_REDIRECT_URL, LOGOUT_URL, } from "../../../@common/Utils/RedirectUrls";
import NonLoggedInUserRibbon from "./NonLoggedInUser/NonLoggedInUserRibbon";
import LoggedInUserRibbon from "./LoggedInUser/LoggedInUserRibbon";
import { useIsLoggedIn } from "base-ui-generic/Common/hooks/useIsLoggedIn";
import { CircularProgress } from "@mui/material";
import { EmailProvider } from "../Context/EmailContext";
import { LOGOUT_ADMIN_REDIRECT_URL, LEGACY_LOGOUT_REDIRECT_URL, } from "base-ui-generic/Common/Utils/RedirectURIs";
import { LoadingProvider } from "../Context/LoadingContext";
import { B2Cproviders } from "base-ui-generic/Common/Interfaces/CommonTypes";
import { appInsights } from "../../../setup/logging/loggingSetup";
import { GetFullLoggingInfoForLoggedInUser, GetLoggingErrorFromHandledException, GetLoggingErrorFromUnhandledException, LogException, } from "base-ui-generic/Common/Helpers/LoggingHelper";
function PortalModal(props) {
    var _this = this;
    var isBundledVersion = props.isBundledVersion, actionOnLogout = props.actionOnLogout, isAdmin = props.isAdmin, onProfileClick = props.onProfileClick, dashboardUrl = props.dashboardUrl;
    var _a = useIsLoggedIn(), isLoggedIn = _a.isLoggedIn, loggedInLoading = _a.loggedInLoading;
    var _b = useState(""), login = _b[0], setLogin = _b[1];
    var _c = useState(false), isLoginVisible = _c[0], setLoginVisible = _c[1];
    var _d = useState(false), isLoggedInState = _d[0], setIsLoggedInState = _d[1];
    var _e = useState(false), localLoading = _e[0], setLocalLoading = _e[1]; // to prevent appearing Sign-In button for milliseconds
    useEffect(function () {
        var authType = getAuthenticationType();
        if (!authType) {
            return;
        }
        try {
            var parsedAuthType = parseInt(authType);
            if (isNaN(parsedAuthType)) {
                var errorMessage = GetFullLoggingInfoForLoggedInUser("Error! Incorrect authentication type: " + authType);
                var error = GetLoggingErrorFromHandledException(new Error(errorMessage));
                LogException(appInsights, error);
                clearAllValuesFromStorages();
                window.location.href = LEGACY_LOGOUT_REDIRECT_URL;
            }
            else if (parsedAuthType === B2Cproviders.CORP &&
                window.location.origin !==
                    process.env.REACT_APP_MODERNIZATION_ADMIN_URL) {
                clearAllValuesFromStorages();
                window.location.href = LEGACY_LOGOUT_REDIRECT_URL;
            }
            else if (parsedAuthType !== B2Cproviders.CORP &&
                window.location.origin ===
                    process.env.REACT_APP_MODERNIZATION_ADMIN_URL) {
                clearAllValuesFromStorages();
                window.location.href = LOGOUT_ADMIN_REDIRECT_URL;
            }
        }
        catch (ex) {
            var errorMessage = GetFullLoggingInfoForLoggedInUser("Logout - uncaught exception.");
            var error = GetLoggingErrorFromUnhandledException(ex, errorMessage);
            LogException(appInsights, error);
            clearAllValuesFromStorages();
            window.location.href = LEGACY_LOGOUT_REDIRECT_URL;
        }
    }, []);
    useEffect(function () {
        setLocalLoading(true);
        var loggedIn = isUserLoggedIn();
        if (loggedIn) {
            setIsLoggedInState(true);
        }
        else {
            setIsLoggedInState(false);
        }
        setLocalLoading(false);
    }, [isLoggedIn]);
    useEffect(function () {
        if (isLoggedInState) {
            setLocalLoading(true);
            var userLogin = getLoginName();
            if (userLogin) {
                setLogin(userLogin);
            }
            setLocalLoading(false);
        }
    }, [isLoggedInState, setLogin]);
    var handleLoginPress = function () {
        var _a;
        if (isAdmin) {
            getFromServerAPIWithProvidedBearerToken(CORP_REDIRECT_URL, (_a = process.env.REACT_APP_MODERNIZATION_ADMIN_URL) !== null && _a !== void 0 ? _a : "", {})
                .then(function (response) {
                window.location.href = response;
            })
                .catch(function (ex) {
                var errorMessage = GetFullLoggingInfoForLoggedInUser("isUserCorp - uncaught exception. ");
                var error = GetLoggingErrorFromUnhandledException(ex, errorMessage);
                LogException(appInsights, error);
            });
        }
        else {
            setLoginVisible(function (isVisible) { return !isVisible; });
        }
    };
    var handleLogoutPress = function () { return __awaiter(_this, void 0, void 0, function () {
        var ex_1, errorMessage, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!actionOnLogout) return [3 /*break*/, 2];
                    return [4 /*yield*/, actionOnLogout()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, 5, 6]);
                    return [4 /*yield*/, getFromServerAPIWithoutRedirections(LOGOUT_URL, appInsights)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    ex_1 = _a.sent();
                    errorMessage = GetFullLoggingInfoForLoggedInUser("Handle Logout Press - uncaught exception.");
                    error = GetLoggingErrorFromUnhandledException(ex_1, errorMessage);
                    LogException(appInsights, error);
                    return [3 /*break*/, 6];
                case 5:
                    clearAllValuesFromStorages();
                    setIsLoggedInState(false);
                    if (isAdmin) {
                        window.location.href = LOGOUT_ADMIN_REDIRECT_URL;
                    }
                    else {
                        window.location.href = LEGACY_LOGOUT_REDIRECT_URL;
                    }
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var hideLoginModal = function () {
        if (isLoginVisible) {
            setLoginVisible(function (isVisible) { return !isVisible; });
        }
    };
    return (_jsx(LoadingProvider, { children: _jsx(EmailProvider, { children: _jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "modernization-header__wrapper", "data-testid": "portal-modal" }, { children: loggedInLoading || localLoading ? (_jsx("div", __assign({ className: "modernization-loader-main-block", "data-testid": "portal-modal-loading" }, { children: _jsx(CircularProgress, { className: "modernization-loader-spinner-main" }) }))) : isLoggedIn && isLoggedInState ? (_jsx(LoggedInUserRibbon, { login: login, handleClickLogout: handleLogoutPress, isAdmin: isAdmin, onProfileClick: onProfileClick, dashboardUrl: dashboardUrl })) : (_jsx(NonLoggedInUserRibbon, { isBundledVersion: isBundledVersion, handleClick: handleLoginPress })) })), isLoginVisible && (_jsx(LoginModal, { isActive: isLoginVisible, handleClose: hideLoginModal })), _jsx("div", { onClick: hideLoginModal, className: "content" })] }) }) }));
}
export default PortalModal;
